import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import general from './de/general.json';
import components from './de/components.json';

/**
 * Default namespace for translations.
 */
export const defaultNS = 'general';

/**
 * Resources object containing translation files.
 */
export const resources = {
    general,
    components
}

/**
 * Initializes the i18n instance with configuration settings.
 * 
 * - `lng`: Default language set to German ('de').
 * - `fallbackLng`: Fallback language set to German ('de').
 * - `debug`: Debugging is disabled.
 * - `resources`: Contains the translation resources for the application.
 * - `defaultNS`: Sets the default namespace for translations.
 */
i18n.use(initReactI18next).init({
  lng: 'de',
  fallbackLng: "de",
  debug: false,
  resources: {
    de: resources,
  },
  defaultNS,
});

export default i18n;